import React from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getProfile, restoreDomain, setgmailAddOnFromMarketPlace} from '../actions/profileActions';
import {setDetailsForContactCard} from '../actions/contactActions';
import {
	calendlyWidget,
	googleSignIn, loadZohoSalesIQ,
	urlParam,
} from './utils';
import InvitedRegisteredGrantedRedirectAllowTemplate
	from './components/template/components/invited-registered-granted-redirect-allow-template';
import NotReadyTemplate from './components/template/components/not-ready-template';
import NotRegisteredTemplate from './components/template/components/not-registered-template';
import RegisteredNotGrantedTemplate from './components/template/components/registered-not-granted-template';
import RegisteredGrantedTemplate from './components/template/components/registered-granted-template';
import UpgradingTemplate from './components/template/components/upgrading-template';
import MobileRedirect from './screens/mobile-redirect'
import {isMobileOnly, isTablet} from 'react-device-detect';
import {API_ROOT} from './utils';
import Loader from './components/sprite/components/loader'
import queryString from 'query-string';
import GlitchRecorder from './utils/glitchRecorder';
import {checkChromeExtension} from '../actions/checkChromeExtensionActions';
import {isLabelSelectedOnMobile, isMobileOrTabletDetected} from '../actions/mobileActions';
import './index.css';
import Button from "./components/button";

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loaderLoading: true,
			forceWebDisplay: false
		};
		this.handleForceWebDisplay = this.handleForceWebDisplay.bind(this);
		this.handleRestoreDomain = this.handleRestoreDomain.bind(this);
		this.resize = this.resize.bind(this);
	}

	componentDidMount() {
		let qs;

		this.props.getProfile(true);

		if (isMobileOnly && !isTablet) {
			this.props.setIsMobileOrTabletDetected(true);
		} else {
			qs = queryString.parse(this.props.location.search);

			if (qs.landingSite === 'GSC_CHROME_EXTENSION') {
				localStorage.setItem('chromeExtensionUser', true);
			} else if (qs.landingSite === 'GSC_GMAIL_ADDON' && qs.src === 'gsminstallgmailaddon') {
				localStorage.setItem('gmailAddOnFromMarketPlace', true);
				this.props.setgmailAddOnFromMarketPlace('gmail_add_on_marketplace');
			} else if (qs.landingSite === 'GSC_DRIVE_ADDON' && qs.src === 'gsminstallgmailaddon') {
				localStorage.setItem('gmailAddOnFromMarketPlace', true);
				localStorage.setItem('gmailAddOnFromDrive', true);
				this.props.setgmailAddOnFromMarketPlace('gmail_add_on_marketplace');
			} else if (qs.landingSite === 'GSC_CALENDAR_ADDON' && qs.src === 'gsminstallgmailaddon') {
				localStorage.setItem('gmailAddOnFromMarketPlace', true);
				localStorage.setItem('gmailAddOnFromCalendar', true);
				this.props.setgmailAddOnFromMarketPlace('gmail_add_on_marketplace');
			} else {
				let keysToRemove = ['chromeExtensionUser', 'gmailAddOnFromMarketPlace', 'gmailAddOnFromDrive', 'gmailAddOnFromCalendar'];
				keysToRemove.forEach(k =>
					localStorage.removeItem(k))
			}

		}

		if (qs?.contactId || qs?.groupId) {
			this.props.setDetailsForContactCard(qs)
		}

		window.addEventListener("resize", this.resize);
		this.resize();

		if(window.gapi){
			if(window.gapi.auth2 === undefined){
				localStorage.setItem('redirectUrl', this.props.location.pathname);
			} else {
				if(localStorage.getItem('redirectUrl')){
					this.props.history.push(localStorage.getItem('redirectUrl'));
				}
			}
		}

		loadZohoSalesIQ();

		if (window.$zoho) {
			window.$zoho.salesiq.ready = () => {
				if (window.$zoho.salesiq.floatbutton) {
					window.$zoho.salesiq.floatbutton.visible("show");
				}
				if (this.props.profile) {
					if (this.props.profile.name && window.$zoho.salesiq.visitor) {
						window.$zoho.salesiq.visitor.name(this.props.profile.name);
					}
					if (this.props.profile.email && window.$zoho.salesiq.visitor) {
						window.$zoho.salesiq.visitor.email(this.props.profile.email);
					}
				}

				// SalesIQ custom action listener for chat box buttons
				window.$zoho.salesiq.customaction = (actionName, actionData) => {
					if (actionName === 'start_glitch_recording' || actionName === 'start_recording') {
						GlitchRecorder.start();
						if (window.$zoho.salesiq.visitor && typeof window.$zoho.salesiq.visitor.chatmessage === 'function') {
							window.$zoho.salesiq.visitor.chatmessage('🔴 Glitch recording active. Please reproduce your issue now, then click [Stop & Send Logs].');
						} else if (window.$zoho.salesiq.visitor && typeof window.$zoho.salesiq.visitor.question === 'function') {
							window.$zoho.salesiq.visitor.question('🔴 Glitch recording active. Please reproduce your issue now, then click [Stop & Send Logs].');
						}
					} else if (actionName === 'stop_glitch_recording' || actionName === 'stop_recording') {
						GlitchRecorder.stopAndSend();
					}
				};
			};
		}

	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (JSON.stringify(this.props.profile) !== JSON.stringify(prevProps.profile)) {
			if (this.props.profile && this.props.profile.id) {
				let queryParameter = queryString.parse(this.props.location.search);
				if (queryParameter.userId) {
					this.verifyUser(this.props.profile.id);
				} else {
					this.setState({loaderLoading: false})
				}
			}
		}
	}

	verifyUser = (userId) => {
		let queryParameter = queryString.parse(this.props.location.search);
		if (queryParameter.userId !== userId || queryParameter.login_hint !== this.props.profile.email) {
			let request = `${API_ROOT}/account/logout/`;
			axios.get(request, {withCredentials: true}).then(response => {
				let keysToRemove = ['chromeExtensionUser', 'gmailAddOnFromMarketPlace', 'gmailAddOnFromDrive', 'gmailAddOnFromCalendar'];
				keysToRemove.forEach(k => localStorage.removeItem(k));
				let urlForBackend = window.location.href;
				if (queryParameter?.login_hint) {
					window.location.href = urlForBackend
				} else {
					let login_hint = queryParameter.userEmail;
					window.location.href = urlForBackend + `&login_hint=` + login_hint;
				}
			})
		} else {
			this.setState({loaderLoading: false})
		}
	};

	handleForceWebDisplay = () => {
		this.setState({
			forceWebDisplay: true
		});
	};

	resize() {
    	if(window.innerWidth <= 992) {
			if(!this.props.isMobileOrTabletDetected){
				this.props.setIsMobileOrTabletDetected(true);
			}
	    } else {
			if(this.props.isMobileOrTabletDetected){
				this.props.setIsMobileOrTabletDetected(false);

				if(this.props.isLabelSelectedOnMobile){
					this.props.setIsLabelSelectedOnMobile(false);
				}
			}
	    }
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resize);
	}

	handleRestoreDomain () {
		this.props.restoreDomain();
	}

	render() {
		const qs = queryString.parse(this.props.location.search);
		if (this.state.loaderLoading && qs.landingSite === 'GSC_CHROME_EXTENSION') {
			return <Loader/>
		}

		else if (this.props.isMobileOrTabletDetected && !this.state.forceWebDisplay && window.location.pathname !== '/invited/invitation-response') {
			return <MobileRedirect forceWebDisplay={this.handleForceWebDisplay}/>
		}

		else if (this.props.profile !== null) {

			if(this.props.profile.isBlockedDomain){
				return (
					<div className="p-3 text-center">
						<p>This domain is not allowed to access the app.</p>
					</div>
				)
			}

			if(this.props.profile.domain?.deleted) {
				return (
					<div className="p-3 text-center">
						<p>This domain has been deleted.</p>
						<Button onClick={this.handleRestoreDomain} className="btn-primary">Restore the domain</Button>
					</div>
				)
			}

			googleSignIn();

			if(document.head.innerHTML.includes("https://assets.calendly.com/assets/external/widget.js") === false){
				calendlyWidget();
			}

			if (
				this.props.profile.status.includes('notRegistered') ||
				this.props.profile.status.includes('NotRegistered')
			) {
				return <NotRegisteredTemplate/>;

			} else if (
				this.props.profile.status === 'invitedRegisteredGrantedRedirectAllow'
			) {

				return <InvitedRegisteredGrantedRedirectAllowTemplate/>;

			} else if (
				this.props.profile.status === 'registeredNotGranted' ||
				this.props.profile.status === 'invitedRegisteredNotGranted'
			) {

				if (window.location.search.includes('impersonate') === false) {
					return <RegisteredNotGrantedTemplate/>;
				} else {
					return <RegisteredGrantedTemplate/>;
				}
			} else {
				if (urlParam('page') === 'upgrade') {
					return <UpgradingTemplate/>;
				} else {
					return <RegisteredGrantedTemplate/>;
				}
			}
		} else {
			if (urlParam('page') === 'upgrade') {
				return <NotReadyTemplate/>;
			} else {
				return <NotReadyTemplate/>;

			}
		}
	}
}

const mapStateToProps = (state) => ({
	profile: state.profileReducer.getProfile,
	isMobileOrTabletDetected: state.mobileReducer.isMobileOrTabletDetected,
	isLabelSelectedOnMobile: state.mobileReducer.isLabelSelectedOnMobile,
});

const mapDispatchToProps = (dispatch) => ({
	getProfile: (boolean) => dispatch(getProfile(boolean)),
	checkChromeExtension: (boolean) => dispatch(checkChromeExtension(boolean)),
	setgmailAddOnFromMarketPlace: (string) => dispatch(setgmailAddOnFromMarketPlace(string)),
	setDetailsForContactCard: (object) => dispatch(setDetailsForContactCard(object)),
	setIsMobileOrTabletDetected: (boolean) => dispatch(isMobileOrTabletDetected(boolean)),
	setIsLabelSelectedOnMobile: (boolean) => dispatch(isLabelSelectedOnMobile(boolean)),
	restoreDomain: () => dispatch(restoreDomain())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
